module.exports = __webpack_public_path__ + "static/media/reportTableScreenshot.3e744c2e.png";